import { formatDate } from 'components/CallToAction/utils'
import {
  featureIconDictionary,
  featureNameDictionary,
  pendingTexts,
} from '../../list/dictionaries'

export const numberWithDots = x =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

export const parseFeatures = (features, areas) => {
  const newFeatures = []

  Object.keys(Object.assign(features, areas)).map((feature, idx) => {
    const value = feature.includes('area_')
      ? areas[feature].value
      : features[feature]

    const measurementUnit = feature.includes('area_')
      ? areas[feature].unidade_medida
      : ''

    if (
      featureNameDictionary[feature] &&
      featureIconDictionary[feature] &&
      value !== null &&
      value
    ) {
      newFeatures.push({
        id: idx,
        feature: featureNameDictionary[feature],
        amount: value,
        icon: featureIconDictionary[feature],
        unit: measurementUnit,
      })
    }
    return null
  })

  return newFeatures
}

export const parseExpenses = despesas => {
  if (!despesas.length) {
    return []
  }
  return despesas.map(despesa => {
    if (despesa.type.toLowerCase() === 'iptu') {
      return { ...despesa, type: 'Valor do IPTU (anual)' }
    }
    if (despesa.type.toLowerCase() === 'condominio') {
      return { ...despesa, type: 'Valor do condomínio (mensal)' }
    }
    return despesa
  })
}

export const isAuctionCheck = string => {
  const lowerCaseString = string.toLowerCase()
  if (
    lowerCaseString === 'primeiro leilão' ||
    lowerCaseString === 'segundo leilão' ||
    lowerCaseString === 'primeiro_leilao' ||
    lowerCaseString === 'segundo_leilao' ||
    lowerCaseString === 'primeiro_leilão' ||
    lowerCaseString === 'segundo_leilão' ||
    lowerCaseString === 'leilao' ||
    lowerCaseString === 'leilão'
  ) {
    return true
  }
  return false
}
export const isDirectOrAgencySale = stringToCheck => {
  const directSaleRegex = new RegExp('^venda[_ ]direta$', 'i')
  const agencyRegex = new RegExp('^imobili[aá]ria$', 'i')
  if (directSaleRegex.test(stringToCheck) || agencyRegex.test(stringToCheck)) {
    return true
  }
  return false
}

export const isBestProposal = tipoVenda => {
  const bestProposalRegex = new RegExp('^melhor[ _]proposta$', 'i')

  if (bestProposalRegex.test(tipoVenda)) {
    return true
  }

  return false
}

export const isCompetition = stringToCheck => {
  const competitionRegex = new RegExp('^concorr[eê]ncia[ _]p[uú]blica$')
  const competitionRegexDispute = new RegExp('^melhor[ _]proposta$')
  if (
    competitionRegex.test(stringToCheck) ||
    competitionRegexDispute.test(stringToCheck)
  ) {
    return true
  }
  return false
}

export const isAgencySale = stringToCheck => {
  const agentRegex = new RegExp('^corretor[_ ]aut[oô]nomo$', 'i')
  const agencyRegex = new RegExp('^imobili[aá]ria$', 'i')

  if (agentRegex.test(stringToCheck) || agencyRegex.test(stringToCheck)) {
    return true
  }
  return false
}

export const isLearnMore = call_to_actions => {
  const lowerCallToAction = call_to_actions.toLowerCase()
  const learnMoreRegex = new RegExp('^saiba[ _]mais$', 'i')

  return learnMoreRegex.test(lowerCallToAction)
}

export const isHideDisplay = checkedString => {
  const lowerCheckedString = checkedString.toLowerCase()
  const hideRegex = new RegExp('^n[aã]o[ _]exibir$', 'i')

  return hideRegex.test(lowerCheckedString)
}

export const isClosed = stringToCheck => {
  return stringToCheck.toLowerCase() === 'encerrado'
}

export const isSold = stringToCheck => {
  return stringToCheck.toLowerCase() === 'vendido'
}

export const isSacre = conditions => {
  return (
    conditions.parcelamento_direto &&
    conditions.parcelamento_direto.sistema_amortizacao &&
    conditions.parcelamento_direto.sistema_amortizacao === 'price'
  )
}

export const isSaleValue = stringToCheck => {
  const lowerCheckedString = stringToCheck.toLowerCase()
  const saleValueRegex = new RegExp('^valor[ _]venda$', 'i')

  return saleValueRegex.test(lowerCheckedString)
}

export const isReferenceValue = stringToCheck => {
  const lowerCheckedString = stringToCheck.toLowerCase()
  const referenceValueRegex = new RegExp('^valor[ _]refer[eê]ncia$', 'i')

  return referenceValueRegex.test(lowerCheckedString)
}

export const isUpFrontValue = stringToCheck => {
  const lowerCheckedString = stringToCheck.toLowerCase()
  const upFrontValueRegex = new RegExp('^valor[ _]vista$', 'i')

  return upFrontValueRegex.test(lowerCheckedString)
}

export const paymentConditionSwitch = (bankOption, bank) => {
  switch (bankOption) {
    case 'escolha_cliente':
      return 'Pode ser financiado em banco da escolha do cliente.'
    case 'somente_banco':
      return `Financiado somente pelo Banco ${bank}`
    case 'condicao_banco':
      return `Financiado em condição especial pelo Banco ${bank}`
    default:
      return ''
  }
}

export const checkIsActiveByDate = data_limite => {
  const [auctionDate, auctionHour] = data_limite?.split(' ', 2) || []

  const dt_limite =
    auctionDate && auctionHour && formatDate(auctionDate, auctionHour)

  const expiration_date = new Date() >= new Date(dt_limite)

  const isAuctionActive = !data_limite || expiration_date

  return [isAuctionActive, expiration_date]
}

export const transformPendingTexts = pending => {
  if (!pending) return pending

  const separatePending = pending.split(',')

  const treatedText = separatePending
    .filter(element => pendingTexts[element])
    .map(element => pendingTexts[element])

  return treatedText
}

export const formatDateToPreActive = initial => {
  const [date, hour] = initial.split(' ')

  const formatedDate = date
    .split('/')
    .reverse()
    .join('-')

  return `${formatedDate} ${hour}`
}

export const parseMakeProposal = (makeProposal, wallet) => {
  const KEYS = {
    leilao: 'auction',
    outros_tipos_venda: 'otherSaleTypes',
    comissao: 'commission',
    plataforma: 'platform',
    pagimovel: 'pagimovel',
    caucao: 'deposit',
    habilitada: 'enabled',
    percentual: 'percentage',
    piso: 'floor',
    teto: 'ceiling',
  }

  const KEYS_WALLET = {
    ativo: 'active',
    percentual_aceito_abaixo_valor_venda: 'acceptedPercentageBelowSaleValue',
  }

  const parseObject = (object, keys) => {
    if (Array.isArray(object)) {
      return object.map(item => parseObject(item, keys))
    }

    if (object !== null && typeof object === 'object') {
      return Object.fromEntries(
        Object.entries(object)
          .filter(([key]) => key in keys)
          .map(([key, value]) => [keys[key], parseObject(value, keys)])
      )
    }

    return object
  }

  return {
    ...parseObject(makeProposal, KEYS),
    ...parseObject(wallet, KEYS_WALLET),
  }
}

export const isAuctionSalesChannel = salesChannelType =>
  (salesChannelType || '').toLowerCase() === 'leiloeiro'

// Honorario de cada campo (comissao/plataforma/pagimovel) e sempre um
// percentual do valor LIQUIDO da proposta, limitado a piso/teto quando
// preenchidos (ver "Como calcular valor_total_proposta" na doc da API FSP).
const calculateFee = (field, netValue) => {
  if (!field?.enabled) return 0

  const percentage = Number(field.percentage)
  if (!Number.isFinite(percentage)) return 0

  let fee = (percentage / 100) * netValue

  // piso 0/nulo nao altera nada (fee nunca e negativo); teto 0/nulo = sem teto.
  const floor = Number(field.floor)
  if (Number.isFinite(floor) && fee < floor) fee = floor

  const ceiling = Number(field.ceiling)
  if (ceiling && Number.isFinite(ceiling) && fee > ceiling) fee = ceiling

  return fee
}

export const getProposalFees = (section, netValue) =>
  ['commission', 'platform', 'pagimovel'].reduce(
    (total, key) => total + calculateFee(section?.[key], netValue),
    0
  )

export const getSelectedProposalSection = (makeProposal, salesChannelType) =>
  isAuctionSalesChannel(salesChannelType)
    ? makeProposal?.auction
    : makeProposal?.otherSaleTypes

// O campo do formulario pede o valor TOTAL (com honorarios inclusos), mas a
// API calcula os honorarios a partir do valor LIQUIDO: total = liquido +
// honorarios(liquido). Como total(liquido) e monotonica crescente (a
// parcela "liquido" tem coeficiente 1, e cada honorario e clamp(...) de uma
// funcao nao decrescente de liquido), resolvemos o liquido por bisseccao.
export const resolveNetProposalValue = (section, totalValue) => {
  if (!(totalValue > 0)) return 0

  let low = 0
  let high = totalValue

  for (let i = 0; i < 60; i += 1) {
    const mid = (low + high) / 2
    const total = mid + getProposalFees(section, mid)

    if (total < totalValue) {
      low = mid
    } else {
      high = mid
    }
  }

  return (low + high) / 2
}

// netSaleValue = valor LIQUIDO do imovel (valores.valor_sem_comissao), a mesma
// base que o backend usa no desagio. O minimo aceito e liquido x (1 - %) e e
// comparado com o liquido da proposta, nunca com o valor de venda c/ honorarios.
export const isProposalValueBelowNegotiationRange = (
  makeProposal,
  netSaleValue,
  proposalValue,
  salesChannelType
) => {
  if (!makeProposal || !netSaleValue || !(proposalValue > 0)) return false

  const acceptedPercentageBelowSaleValue = Number(
    makeProposal.acceptedPercentageBelowSaleValue
  )
  if (!Number.isFinite(acceptedPercentageBelowSaleValue)) return false

  const section = getSelectedProposalSection(makeProposal, salesChannelType)
  const netValue = resolveNetProposalValue(section, proposalValue)
  const minAcceptedValue =
    netSaleValue * (1 - acceptedPercentageBelowSaleValue / 100)

  return netValue < minAcceptedValue
}

export const roundHalfUp = (value, decimals = 2) => {
  const factor = 10 ** decimals
  return Math.round((value + Number.EPSILON) * factor) / factor
}

// valor_liquido_proposta e valor_total_proposta a enviar pra API FSP
// (POST /pipefy/fsp/proposal), calculados a partir do valor total que o
// cliente digitou no formulario (ver "Como calcular valor_total_proposta").
export const getProposalApiAmounts = (
  makeProposal,
  proposalValue,
  salesChannelType
) => {
  const section = getSelectedProposalSection(makeProposal, salesChannelType)
  const netValue = resolveNetProposalValue(section, proposalValue)
  const fees = getProposalFees(section, netValue)

  return {
    valorLiquidoProposta: roundHalfUp(netValue),
    valorTotalProposta: roundHalfUp(netValue + fees),
  }
}
